import { createFileRoute } from "@tanstack/react-router";

import { findAreaBySlug } from "@/data/local-areas";
import { routeHead } from "@/lib/seo-head";
import LocalAreaPage from "@/pages/LocalAreaPage";

export const Route = createFileRoute("/architecte-interieur-tassin-la-demi-lune")({
  head: () => {
    const area = findAreaBySlug("architecte-interieur-tassin-la-demi-lune");
    return routeHead({
      path: "/architecte-interieur-tassin-la-demi-lune",
      title: `Architecte d'intérieur ${area?.city ?? "Lyon"} | JIIA Studio`,
      description: area?.intro ?? "",
    });
  },
  component: LocalAreaPage,
});
